import {action, observable, makeObservable} from 'mobx';

export class OB_Screen {
    @observable isSubmitting: boolean = false;
    @observable isLoading: boolean = false;
    @observable error?: boolean;

    constructor() {
        makeObservable(this);
    }

    @action setLoading = (flag: boolean) => (this.isLoading = flag);
    @action setSubmitted = (flag: boolean) => (this.isSubmitting = flag);
    @action setError = (err: boolean) => (this.error = err);
}
